import "./App.css";
import { Route, HashRouter as Router, Routes } from "react-router-dom";
import { lazy, Suspense } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useState, useEffect } from "react";
import "./utils/firebase";

function App() {
  const Dashboard = lazy(() => import("./pages/Dashboard"));
  const Calculator = lazy(() => import("./pages/Calculator"));
  const Login = lazy(() => import("./pages/Login"));
  const NewRecord = lazy(() => import("./pages/NewRecord"));
  const EditUser = lazy(() => import("./pages/EditUser"));
  const User = lazy(() => import("./pages/User"));
  const NumBoard = lazy(() => import("./pages/NumBoard"));
  const AccessDeniedAlert = lazy(() =>
    import("./components/AccessDeniedAlert")
  );

  const auth = getAuth();
  const [isLogged, setLogStatus] = useState(false);

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        const uid = user.uid;
        setLogStatus(true);
      } else {
        setLogStatus(false);
      }
    });
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            index
            element={
              <Suspense>{isLogged ? <Dashboard /> : <Login />}</Suspense>
            }
          />
          <Route
            path="/dashboard"
            element={
              <Suspense>
                {isLogged ? <Dashboard /> : <Login />}
              </Suspense>
            }
          />
          <Route
            path="/calculator"
            element={
              <Suspense>
                {isLogged ? <Calculator /> : <Login />}
              </Suspense>
            }
          />

          <Route
            path="/newRecord"
            element={
              <Suspense>
                {isLogged ? <NewRecord /> : <Login />}
              </Suspense>
            }
          />

          <Route
            path="/user/:ArrayId"
            element={
              <Suspense>{isLogged ? <User /> : <Login />}</Suspense>
            }
          />

          <Route
            path="/editUser/:id"
            element={
              <Suspense>
                {isLogged ? <EditUser /> : <Login />}
              </Suspense>
            }
          />

          <Route
            path="/NumBoard/:id"
            element={
              <Suspense>
                {isLogged ? <NumBoard /> : <Login />}
              </Suspense>
            }
          />

          <Route
            path="/login"
            element={
              <Suspense>
                <Login />
              </Suspense>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
